module.exports = __webpack_public_path__ + "static/media/example_BOMs.66729d3f.xlsx";